export const sortBySortingIndex = (
	a: { sortingIndex: number },
	b: { sortingIndex: number },
) => a.sortingIndex - b.sortingIndex;
